<template>
  <div
    v-if="$parent.inMeeting"
    id="bottomControls"
    :class="{ 'control-is-mobile': $parent.isMobile() }"
    class="fixed-bottom meeting-controls d-flex">
    <div
      v-if="!desktopMinimizedMode"
      :data-title="$t('MEETING.CONTROLS_DISPLAY_LAYOUT')"
      id="layout"
      style="--bottom: 3.5em;"
      class="mr-auto layoutLauncher control"
      tabindex="0"
      @click="changeVideoLayout()">
      <grid-icon
        v-if="selectedVideoLayout"
        :size="32"
        title=""/>
      <gesture-tap-icon
        v-if="!selectedVideoLayout"
        :size="32"
        title=""/>
    </div>
    <div
      v-if="desktopMinimizedMode"
      class="mr-auto layoutLauncher control"
      tabindex="0"/>
    <div class="m-auto">
      <span
        v-if="canSeeAudioVideoCtrls"
        :data-title="toggleText(camera,'_VIDEO')"
        :class="{'middle-controls': !$parent.isMobile() }"
        style="--bottom: 4em;"
        class="d-inline-block control "
        @click="toggleCamera()">
        <video-icon
          v-if="camera"
          id="video"
          :size="32"
          title=""/>
        <video-off-icon
          v-else
          id="video-off"
          :size="32"
          class="muted"
          title=""/>
      </span>
      <span
        v-if="canSeeAudioVideoCtrls"
        :data-title="toggleText(mic,'_ME', 'CONFIGURE.MUTE', 'CONFIGURE.UNMUTE')"
        style="--bottom: 4em;"
        class="d-inline-block control middle-controls"
        @click="toggleMic()">
        <microphone-icon
          v-if="mic"
          id="mic"
          :size="32"
          title=""/>
        <microphone-off-icon
          v-else
          id="mic-off"
          :size="32"
          class="muted"
          title=""/>
      </span>
      <span
        v-if="!$parent.isIos()"
        :data-title="toggleText(speaker,'_AUDIO')"
        :class="{'middle-controls': !$parent.isMobile() }"
        style="--bottom: 4em;"
        class="d-inline-block control"
        @click="toggleSpeaker()">
        <volume-high-icon
          v-if="speaker"
          id="speaker"
          :size="32"
          title=""/>
        <volume-off-icon
          v-else
          id="speaker-off"
          :size="32"
          class="muted"
          title=""/>
      </span>
      <span
        v-if="!$parent.isMobile() && canSeeAudioVideoCtrls && !desktopMinimizedMode"
        v-show="desktopControls"
        :data-title="toggleText(desktop,'_SHARESCREEN')"
        style="--bottom: 4em;"
        class="d-md-inline-block control middle-controls d-none"
        @click="onDesktopChange()">
        <screen-share-icon
          v-if="!desktop"
          id="desktop"
          :size="32"
          title=""/>
        <screen-share-stop-icon
          v-else
          id="desktop-off"
          :size="32"
          class="muted"
          title=""/>
      </span>
      <b-btn
        v-if="!desktopMinimizedMode"
        :class="{'middle-controls': !$parent.isMobile() }"
        :data-title="$t('MEETING.OPEN_MORE_MEETING_CONTROLS')"
        class="control d-inline-block"
        id="inMeetingSettings"
        href="#"
        tabindex="0"
        variant="link"
        style="padding:0px; vertical-align: unset;--bottom: 4em;"
        @click="amImoderator()">
        <dots-horizontal-icon
          :size="32"
          title=""/>
      </b-btn>
      <b-popover
        v-if="!desktopMinimizedMode"
        ref="meetingSettings"
        target="inMeetingSettings"
        triggers="focus"
        placement="top">
        <ul class="list-unstyled setting-list">
          <!-- <li
            class="d-flex position-relative"
            @click="toggleSystemMessages()">
            <alert-icon
              :size="20"
              class="mr-2"/>
            {{ $parent.$refs.sideBar.system ? $t('MEETING.HIDE_SYS_MSGS') : $t('MEETING.SHOW_SYS_MSGS') }}
          </li> -->
          <li
            v-if="!moderator"
            class="d-flex position-relative"
            @click="launchMakeModerator()">
            <moderator-key-icon
              :size="20"
              class="mr-2"/>
            {{ $t('MEETING.ENTER_MOD_KEY') }}
          </li>
          <li
            v-if="moderator && !$parent.isIos()"
            class="d-flex position-relative"
            @click="muteUsersAudio()">
            <microphone-off-icon
              :size="20"
              class="mr-2"/>
            {{ $t('MEETING.MUTE_AUDIO_ALL') }}
          </li>
          <li
            v-if="moderator"
            class="d-flex position-relative"
            @click="muteUsersVideo">
            <video-off-icon
              :size="20"
              class="mr-2"/>
            {{ $t('MEETING.MUTE_VIDEO_ALL') }}
          </li>
          <li
            v-if="moderator && isRecordingSupported()"
            class="d-flex position-relative"
            @click="toggleRecording">
            <record-icon
              :size="20"
              class="mr-2"/>
            {{ isRecording ? $t('MEETING.MORE_STOP_RECORDING') : $t('MEETING.MORE_START_RECORDING') }}
          </li>
          <!-- <li
            v-if="$parent.$refs.sideBar.$refs.sidePart.amImoderator"
            class="d-flex position-relative"
            @click="toogleLock()">
            <lock-outline-icon
              :size="20"
              class="mr-2"/>
            {{ isMeetingLocked ? $t('MEETING.UNLOCK_MEETING') : $t('MEETING.LOCK_MEETING') }}
          </li> -->
          <!-- <li
            v-if="$parent.$refs.sideBar.$refs.sidePart.amImoderator"
            class="d-flex position-relative"
            @click="$parent.makeWaitingRoom(!$parent.meetingInfo.waitingRoom); $refs.meetingSettings.$emit('close')">
            <waiting-room-icon
              :size="20"
              class="mr-2"/>
            {{ $parent.meetingInfo.waitingRoom ? $t('MEETING.DISABLE_WAIT_ROOM') : $t('MEETING.ENABLE_WAIT_ROOM') }}
          </li> -->
          <hr v-if="moderator">
          <li
            class="d-flex position-relative"
            @click="launchSettings('video')">
            <video-icon
              :size="20"
              class="mr-2"/> {{ $t('MEETING.CONTROLS_VIDEO_PREF') }}
          </li>
          <li
            class="d-flex position-relative"
            @click="launchSettings('audio')">
            <microphone-icon
              :size="20"
              class="mr-2 d-flex"/> {{ $t('MEETING.CONTROLS_AUDIO_PREF') }}
          </li>
        </ul>
      </b-popover>
    </div>
    <div class="control ml-auto danger-hover">
      <span>
        <b-btn
          v-if="desktopMinimizedMode"
          :data-title="$t('MEETING.MEETING_EXPAND_VIEW')"
          class="expand"
          style="--bottom: 3.1em;"
          variant="green"
          @click="expandMeetingView()">
          {{ $t('MEETING.MEETING') }}
        </b-btn>
      </span>
      <span class="control ml-auto danger-hover">
        <exit-to-app-icon
          v-if="$parent.isMobile()"
          :data-title="$t('MEETING.TITLELEAVE')"
          :size="32"
          tabindex="0"
          title=""
          @click="launchLeave()"/>
        <b-btn
          v-if="!$parent.isMobile()"
          :data-title="$t('MEETING.TITLELEAVE')"
          style="margin-top:5px;--bottom: 3.1em;"
          variant="red"
          @click="launchLeave()">
          {{ $t('MEETING.LEAVE') }}
        </b-btn>
      </span>
    </div>
  </div>
</template>


<script>
import VolumeIndicator from './VolumeIndicator'
import { ref, computed, onBeforeUnmount } from "@vue/composition-api"
import NoVideoIcon from "../icons/NoVideo"
import ExitToAppIcon from "icons/ExitToApp"
import MicrophoneIcon from "icons/Microphone"
import MicrophoneOffIcon from "icons/MicrophoneOff"
import VideoIcon from "icons/Video"
import VideoOffIcon from "icons/VideoOff"
import VolumeHighIcon from "icons/VolumeHigh"
import VolumeOffIcon from "icons/VolumeOff"
import RadioboxMarkedIcon from "icons/RadioboxMarked"
import ScreenShareIcon from "../icons/ScreenShare"
import ScreenShareStopIcon from "../icons/ScreenShareStop"
import DotsHorizontalIcon from "icons/DotsHorizontal"
import ChevronDownIcon from "icons/ChevronDown"
import CogIcon from "icons/Cog"
import AccountVoiceIcon from "icons/AccountVoice"
import AlertIcon from "icons/Alert"
import LimitedIcon from "../icons/Limited"
import WaitingRoomIcon from "../icons/WaitingRoom"
import CheckIcon from "icons/Check"
import ModeratorKeyIcon from '../icons/ModeratorKey'
import LockOutlineIcon from "icons/LockOutline"
import GestureTapIcon from "icons/GestureTap"
import GridIcon from "../icons/Grid"
import { gaEvent } from '../functions/gtag'
import { getItem } from '../functions/storageManager'
import { getBrowser } from '../functions/browserDetails'

export default {
  name: 'MeetingControlsJitsi',
  components: {
    'volume-indicator': VolumeIndicator,
    'no-video-icon': NoVideoIcon,
    'exit-to-app-icon': ExitToAppIcon,
    'microphone-icon': MicrophoneIcon,
    'microphone-off-icon': MicrophoneOffIcon,
    'video-icon': VideoIcon,
    'video-off-icon': VideoOffIcon,
    'record-icon': RadioboxMarkedIcon,
    'volume-high-icon': VolumeHighIcon,
    'volume-off-icon': VolumeOffIcon,
    'screen-share-icon': ScreenShareIcon,
    'screen-share-stop-icon': ScreenShareStopIcon,
    'dots-horizontal-icon': DotsHorizontalIcon,
    'chevron-down-icon': ChevronDownIcon,
    'cog-icon': CogIcon,
    'account-voice-icon': AccountVoiceIcon,
    'alert-icon': AlertIcon,
    'limited-icon': LimitedIcon,
    'waiting-room-icon': WaitingRoomIcon,
    'check-icon': CheckIcon,
    'moderator-key-icon': ModeratorKeyIcon,
    'lock-outline-icon': LockOutlineIcon,
    'gesture-tap-icon': GestureTapIcon,
    'grid-icon': GridIcon,
  },
  setup(props, context) {
    const selectedShareOption = ref('window')
    const mic = ref("")
    const speaker = ref(true)
    const miceControls = ref(true)
    const cameraControls = ref(true)
    const camera = ref("")
    const desktopControls = ref(true)
    const desktop = ref(false)
    const selectedVideoLayout = ref(true)
    const updater = ref({})
    const isRecording = ref(false)
    const desktopMinimizedMode = ref(false)
    const moderator = ref(false)

    var updaterInterval = 3000
    var updaterTimeout = null
    camera.value = getItem('cameraOn') !== undefined ? getItem('cameraOn') : false
    mic.value = getItem('miceOn') !== undefined ? getItem('miceOn') : false
    const canSeeAudioVideoCtrls = computed(() => {
      return true
    })

    updater.value = setInterval(onTimer, updaterInterval)

    // function mapped to window so can b called from Java code
    window.javaLeave = javaLeave

    onBeforeUnmount(() => {
      clearInterval(updater.value)
    })

    /* context.root.api.isVideoMuted().then(muted => {
      if (!muted)
        toggleCamera()
    })

    context.root.api.isAudioMuted().then(muted => {
      if (!muted)
        toggleMic()
    }) */

    context.root.api.addEventListener(`tileViewChanged`, (value) => {
      if (value.enabled != selectedVideoLayout.value)
        selectedVideoLayout.value = value.enabled
    })

    context.root.api.addEventListener('recordingStatusChanged', (e) => {
      if (e.mode && e.mode === 'local') {
        isRecording.value = e.on
      }
    })

    // // does not work reliably. maybe in future will and will be used to control mic status
    // context.root.api.addEventListener('audioMuteStatusChanged', (e) => {
    //   mic.value = !e.muted;
    // })

    context.root.api.addEventListener('videoMuteStatusChanged', (e) => {
      camera.value = !e.muted;
    })

    context.root.api.addEventListener('screenSharingStatusChanged', (e) => {
      desktop.value = e.on
      if (desktop.value) {
        if (getBrowser().firefox) {
          context.root.api.executeCommand('hideNotification', 'ff_screenshare_notification');
        }
        gaEvent({'ACTION': 'action', 'video_action': 'deskOn'})
      } else {
        gaEvent({'ACTION': 'action', 'video_action': 'deskOff'})
      }
    })

    function amImoderator() {
      if (context.parent.$refs.sideBar && context.parent.$refs.sideBar.$refs.sidePart) {
        let index = context.parent.$refs.sideBar.$refs.sidePart.participantList.findIndex(part => part.id === -1 || part.me)
        moderator.value = index >=0 && context.parent.$refs.sideBar.$refs.sidePart.participantList[index].role === 'moderator'
        return moderator.value
      }
      moderator.value = false;
      return false
    }

    function changeVideoLayout() {
      context.root.api.executeCommand('toggleTileView')
    }

    function onDesktopChange () {
      if (getBrowser().firefox && !desktop.value) {
        context.root.api.executeCommand('showNotification', {
          uid: 'ff_screenshare_notification',
          title: context.root.$t('MEETING.FIREFOX_SCREENSHARE_NOTIFY_TITLE'),
          description: context.root.$t('MEETING.FIREFOX_SCREENSHARE_NOTIFY_DESC'),
          timeout: 'sticky'
        });
      }
      context.root.api.executeCommand('toggleShareScreen')
    }

    function toggleCamera () {
      camera.value = !camera.value
      enableCamera(camera.value)
    }

    function toggleMic () {
      // stop update timer first to not mess with status
      if (updater.value) {
        clearInterval(updater.value);
        updater.value = null;
      }

      mic.value = !mic.value
      enableMike(mic.value)

      // clear timeout if already running - better handling of multiple clicks in short period of time
      if (updaterTimeout) {
        clearTimeout(updaterTimeout);
      }

      // start update timer again with 2 seconds delay
      updaterTimeout = setTimeout(() => {
        updater.value = setInterval(onTimer, updaterInterval);
        updaterTimeout = null;
      }, 2000);
    }

    function toggleSpeaker() {
      speaker.value = !speaker.value
      let volumeLvl = speaker.value ? 1 : 0
      if (context.parent.$refs.sideBar) {
        context.parent.$refs.sideBar.$refs.sidePart.participantList.forEach (value => {
          if (value.me) {
            return
          }
          context.root.api.executeCommand('setParticipantVolume', value.id, volumeLvl)
        })
      }
    }

    function toggleText (check, string, verbFrom = 'CONFIGURE.STOP',verbTo='CONFIGURE.START') {
      return (context.root.$t((check ? verbFrom : verbTo) + `${string}`))
    }

    function toggleVideoList() {
      if (context.parent.videoDevices.length > 1) {
        context.refs.videoOptions.style.display = 'block'
      }
    }

    function toggleAudioList() {
      if (context.parent.audioDevices.length > 1) {
        context.refs.audioOptions.style.display = 'block'
      }
    }

    function toggleSystemMessages(){
      gaEvent({'ACTION': 'action', 'video_more': 'sysMessage'})
      context.parent.$refs.sideBar.toggleBar('system')
      context.refs.meetingSettings.$emit('close')
    }

    function enableMike(value) {
      if (value) {
        gaEvent({'ACTION': 'action', 'video_action': 'micOn'})
      } else {
        gaEvent({'ACTION': 'action', 'video_action': 'micOff'})
      }
      context.root.api.executeCommand('toggleAudio')
    }

    function enableCamera(value) {
      if (value) {
        gaEvent({'ACTION': 'action', 'video_action': 'camOn'})
      } else {
        gaEvent({'ACTION': 'action', 'video_action': 'camOff'})
      }
      context.root.api.executeCommand('toggleVideo')
    }

    // called from Java code
    function javaLeave() {
      exitMeeting(false)
    }

    function launchLeave(){
      context.parent.$refs.leaveMeeting.init()
      if (isRecording.value || !context.parent.$refs.leaveMeeting.settings.includes('confirmLeave')) {
        exitMeeting(true)
      } else {
        expandMeetingView();
        this.$bvModal.show('modal-leave')
      }
    }

    function exitMeeting(callJavaCode) {
      if (isRecording.value) {
        expandMeetingView();
        context.parent.$refs.recordingNotify.$refs.leaveRecModal.show()
        return;
      }

      if (window.java && callJavaCode) {
        window.java.leave()
      }
      context.parent.userWantsToLeave = true
      context.root.api.executeCommand('hangup')

      gaEvent({'ACTION': 'leave'})

      window.close()
      if (!window.closed) {
        context.root.$router.push({ name: 'ExitMeeting', params: { url: context.parent.rejoinHref }})
        // window.location.assign('https://www.corenexa.com/')
      }
    }

    function expandMeetingView() {
      if (window.java && desktopMinimizedMode.value) {
        window.java.expandMeetingView();
      }
    }

    function muteUsersAudio() {
      console.log("mute users audio")
      gaEvent({'ACTION': 'action', 'audio_more': 'mute'})
      context.root.api.executeCommand('muteEveryone', 'audio')
      context.refs.meetingSettings.$emit('close')
    }

    function muteUsersVideo() {
      console.log("mute users video")
      gaEvent({'ACTION': 'action', 'video_more': 'mute'})
      context.root.api.executeCommand('muteEveryone', 'video')
      context.refs.meetingSettings.$emit('close')
    }

    function launchSettings(pane){
      if (pane === 'audio') {
        gaEvent({'ACTION': 'action', 'video_more': 'aSettings'})
      } else if (pane === 'video') {
        gaEvent({'ACTION': 'action', 'video_more': 'vSettings'})
      }
      context.parent.$refs.settings.currentPane = pane
      context.parent.$refs.settings.init()
      this.$bvModal.show('modal-settings')
      context.refs.meetingSettings.$emit('close')
    }

    function launchMakeModerator() {
      this.$bvModal.show('modal-make-moderator')
      context.refs.meetingSettings.$emit('close')
    }

    function toggleRecording() {
      if (isRecording.value) {
        context.root.api.executeCommand('stopRecording', 'local')
      } else {
        context.root.api.executeCommand('startRecording', {
          mode: 'local'
        })
      }

      isRecording.value = !isRecording.value
      context.refs.meetingSettings.$emit('close')
    }

    function isRecordingSupported() {
      let browser = getBrowser()
      if (browser.firefox || browser.safari || window.java) {
        return false
      }

      return true
    }

    function onTimer() {
      context.root.api.isAudioMuted().then(muted => {
        // do not execute if updater was cancelled
        // it could happen as it is async task
        if (updater.value) {
          mic.value = !muted
        }
      })
    }

    return {
      selectedShareOption,
      mic,
      speaker,
      miceControls,
      cameraControls,
      camera,
      desktopControls,
      desktop,
      selectedVideoLayout,
      desktopMinimizedMode,
      toggleVideoList,
      toggleAudioList,
      enableMike,
      enableCamera,
      expandMeetingView,
      isRecordingSupported,
      toggleText,
      toggleSystemMessages,
      toggleCamera,
      toggleMic,
      toggleSpeaker,
      canSeeAudioVideoCtrls,
      changeVideoLayout,
      exitMeeting,
      onDesktopChange,
      muteUsersAudio,
      muteUsersVideo,
      amImoderator,
      moderator,
      launchSettings,
      launchLeave,
      launchMakeModerator,
      toggleRecording,
      isRecording,
      updater,
      onTimer
    }
  }
}
</script>
<style>
  .control-is-mobile:hover span.material-design-icon { background-color: transparent !important; }

  .expand {
    background-color: #00A833;
    margin-top:5px;
    margin-right: 8px;
  }

  .quit-title {
    font-weight: 600;
    font-size: 16px;
    color:#FFFFFF;
  }
  .quit-title:hover {
    cursor: default;
    background:#4a4a4a !important;
  }
  .quit-leave {
    border-radius: 5px;
    font-weight: 600;
    color: #E72113;
    background: #F8F8F8;
  }
  .quit-leave:hover {
    background: #F8F8F8 !important;
    opacity: 0.8;
  }
  .end-webinar {
    margin-top: 50px;
    border-radius: 5px;
    font-weight: 600;
    color: #F8F8F8;
    background: #E72113;
  }
  .end-webinar:hover {
    background: #E72113 !important;
    opacity: 0.8;
  }
  .btn-link, .btn-link:hover {
    font-weight: 400;
    color: #f8f8f8;
    text-decoration: none;
  }
  [data-title]:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
  }
  [data-title]:after {
    content: attr(data-title);
    position: absolute;
    bottom: var(--bottom);
    left: 0%;
    padding: 2px 8px;
    color: #F8F8F8;
    font-weight: 600;
    font-size: 12px;
    line-height: 160%;
    white-space: nowrap;
    border-radius: 4px;
    background: #000000;
    box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.11), 0px 3.28515px 7.30033px rgba(0, 0, 0, 0.075898), 0px 1.59488px 3.54417px rgba(0, 0, 0, 0.061192), 0px 0.781839px 1.73742px rgba(0, 0, 0, 0.048808), 0px 0.30914px 0.686979px rgba(0, 0, 0, 0.034102);
    opacity: 0;
    z-index: 99999;
    visibility: hidden;
  }
  [data-title] {
    position: relative;
  }
  [data-titleleave]:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
  }
  [data-titleleave]:after {
    content: attr(data-titleleave);
    position: absolute;
    bottom: 1.3em;
    left: -140%;
    padding: 2px 8px;
    color: #F8F8F8;
    font-weight: 600;
    font-size: 12px;
    line-height: 160%;
    white-space: nowrap;
    border-radius: 4px;
    background: #000000;
    box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.11), 0px 3.28515px 7.30033px rgba(0, 0, 0, 0.075898), 0px 1.59488px 3.54417px rgba(0, 0, 0, 0.061192), 0px 0.781839px 1.73742px rgba(0, 0, 0, 0.048808), 0px 0.30914px 0.686979px rgba(0, 0, 0, 0.034102);
    opacity: 0;
    z-index: 99999;
    visibility: hidden;
  }
  [data-titleleave] {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/MeetingControlsJitsi.vue